/**
 * Created by daishuang on 2018/4/11.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie'
import {loginApi} from 'api/login'
import {auth} from 'api/auth'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {},
    state: {
        email: Cookies.get('auth_email'),
        Gtlang: Cookies.get('language'),
        accountAuth: {},
    },
    getters: {
        email: state => state.email,
        lang: state => {
            const googleTagManager = () => {
                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != "dataLayer" ? "&l=" + l : "";
                    j.async = true;
                    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, "script", "dataLayer", "GTM-5LS7WVP");
            };
            if (state.Gtlang.indexOf('en') != -1) {
                googleTagManager()
            }
        }
    },
    mutations: {
        setGtlang(state, data){
            state.Gtlang = data
        },
        setAccountAuth(s, data) {
            s.accountAuth = data;
        },
    },
    actions: {
        Login({commit}, userInfo){
            return new Promise((resolve, reject) => {
                loginApi(userInfo).then(
                    res => {
                        Cookies.set('auth_email', userInfo.email);
                        resolve(res);
                    }
                ).catch(error => {
                    reject(error);
                })
            })
        },
        LoginEn({commit}, userInfo){
            return new Promise((resolve, reject) => {
                loginApi(userInfo).then(
                    res => {
                        Cookies.set('auth_email', userInfo.email);
                        resolve(res);
                    }
                ).catch(error => {
                    reject(error);
                })
            })
        },
    }


});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js